import {
  FaBoltLightning,
  FaCoins,
  FaGlobe,
  FaLock,
  FaRobot,
  FaScaleBalanced,
  FaServer,
  FaShieldHalved,
  FaStar,
  FaWallet,
} from "react-icons/fa6";

export type PartnerTagIconKey =
  | "shield"
  | "bolt"
  | "scale"
  | "lock"
  | "globe"
  | "coins"
  | "wallet"
  | "server"
  | "robot"
  | "star";

export const PARTNER_TAG_ICONS: Record<
  PartnerTagIconKey,
  { label: string; Icon: React.ComponentType<{ className?: string }> }
> = {
  shield: { label: "Shield", Icon: FaShieldHalved },
  bolt: { label: "Lightning", Icon: FaBoltLightning },
  scale: { label: "Regulated", Icon: FaScaleBalanced },
  lock: { label: "Secure", Icon: FaLock },
  globe: { label: "Global", Icon: FaGlobe },
  coins: { label: "Low Fees", Icon: FaCoins },
  wallet: { label: "Fast Payouts", Icon: FaWallet },
  server: { label: "Low Latency", Icon: FaServer },
  robot: { label: "Automation", Icon: FaRobot },
  star: { label: "Top Rated", Icon: FaStar },
};

export type PartnerThemeKey =
  | "emerald"
  | "amber"
  | "blue"
  | "rose"
  | "slate"
  | "cyan";

export const PARTNER_THEMES: Record<
  PartnerThemeKey,
  {
    label: string;
    gradientClass: string;
    textClass: string;
  }
> = {
  emerald: {
    label: "Emerald",
    gradientClass: "from-emerald-500 to-teal-900",
    textClass: "text-white",
  },
  amber: {
    label: "Amber",
    gradientClass: "from-amber-400 to-yellow-600",
    textClass: "text-black",
  },
  blue: {
    label: "Blue",
    gradientClass: "from-blue-600 to-indigo-900",
    textClass: "text-white",
  },
  rose: {
    label: "Rose",
    gradientClass: "from-rose-500 to-fuchsia-800",
    textClass: "text-white",
  },
  slate: {
    label: "Slate",
    gradientClass: "from-slate-500 to-slate-900",
    textClass: "text-white",
  },
  cyan: {
    label: "Cyan",
    gradientClass: "from-cyan-500 to-sky-900",
    textClass: "text-white",
  },
};

export type PartnerTag = { label: string; icon: PartnerTagIconKey };

export type PartnerSlide = {
  id: string;
  title: string;
  subtitle: string;
  buttonLabel: string;
  buttonLink: string;
  theme: PartnerThemeKey;
  tags: PartnerTag[];
};

export function getThemeFromLegacy(logoColor: unknown): PartnerThemeKey | null {
  if (typeof logoColor !== "string") return null;
  const s = logoColor.replace(/\s+/g, " ").trim();
  for (const [k, v] of Object.entries(PARTNER_THEMES)) {
    if (s.includes(v.gradientClass)) return k as PartnerThemeKey;
  }
  if (s.includes("emerald") || s.includes("teal")) return "emerald";
  if (s.includes("amber") || s.includes("yellow") || s.includes("orange")) return "amber";
  if (s.includes("indigo") || s.includes("blue")) return "blue";
  if (s.includes("rose") || s.includes("fuchsia") || s.includes("pink")) return "rose";
  if (s.includes("cyan") || s.includes("sky")) return "cyan";
  return null;
}
